export function getInitials(name, fallback) {
  const safeFallback = fallback || "";
  if (!name) return safeFallback;
  const trimmed = String(name).trim();
  if (!trimmed) return safeFallback;

  const parts = trimmed.split(/\s+/);
  const initials =
    parts.length === 1
      ? parts[0].slice(0, 2)
      : `${parts[0][0] || ""}${parts[1][0] || ""}`;
  const safe = initials || safeFallback;
  return safe.toUpperCase();
}

